// src/components/gestionEvento/siembraManager/MassEditModal.jsx
import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, FormControl, InputLabel, Select, MenuItem
} from '@mui/material';

// Usamos una constante para indicar "no cambiar" un campo
const NO_CHANGE = 'NO_CHANGE';

export default function MassEditModal({ open, onClose, onSave }) {
  // Estado local con los campos que podemos cambiar
  const [massEditValues, setMassEditValues] = useState({
    avance: NO_CHANGE,
    asignacionHeats: NO_CHANGE,
    asignacionPosiciones: NO_CHANGE,
    ordenHeat: NO_CHANGE,
    tipoRondas: NO_CHANGE,
  });

  const handleSave = () => {
    onSave(massEditValues);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Edición Masiva de Configuración</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Elige los valores que quieres aplicar a todas las filas seleccionadas.
          (Si dejas "No cambiar", no se alterará ese campo.)
        </Typography>

        {/* Avance */}
        <FormControl fullWidth sx={{ mb: 2 }} size="small">
          <InputLabel>Avance</InputLabel>
          <Select
            label="Avance"
            value={massEditValues.avance}
            onChange={(e) =>
              setMassEditValues((prev) => ({ ...prev, avance: e.target.value }))
            }
          >
            <MenuItem value={NO_CHANGE}>No cambiar</MenuItem>
            <MenuItem value="porTiempo">Por Tiempos</MenuItem>
            <MenuItem value="porLugarTiempo">Por Lugar y Tiempo</MenuItem>
            <MenuItem value="mejorMarca">Por la mejor marca (campo)</MenuItem>
          </Select>
        </FormControl>

        {/* AsignacionHeats */}
        <FormControl fullWidth sx={{ mb: 2 }} size="small">
          <InputLabel>Asignación de Heats</InputLabel>
          <Select
            label="Asignación de Heats"
            value={massEditValues.asignacionHeats}
            onChange={(e) =>
              setMassEditValues((prev) => ({ ...prev, asignacionHeats: e.target.value }))
            }
          >
            <MenuItem value={NO_CHANGE}>No cambiar</MenuItem>
            <MenuItem value="porMarca">Por marca de siembra</MenuItem>
            <MenuItem value="random">Random</MenuItem>
            <MenuItem value="seedPrelimsAsTimedFinals">Seed Prelims as Timed Finals</MenuItem>
            <MenuItem value="seedTimedFinalsAsPrelims">Seed Timed Finals as Prelims</MenuItem>
            <MenuItem value="seedRnd1of2AsFinals">Seed Rnd 1 of 2 as Finals (campo)</MenuItem>
            <MenuItem value="seedRnd1of1AsPrelims">Seed Rnd 1 of 1 as Prelims (campo)</MenuItem>
          </Select>
        </FormControl>

        {/* AsignacionPosiciones */}
        <FormControl fullWidth sx={{ mb: 2 }} size="small">
          <InputLabel>Asignación de Posiciones</InputLabel>
          <Select
            label="Asignación de Posiciones"
            value={massEditValues.asignacionPosiciones}
            onChange={(e) =>
              setMassEditValues((prev) => ({ ...prev, asignacionPosiciones: e.target.value }))
            }
          >
            <MenuItem value={NO_CHANGE}>No cambiar</MenuItem>
            <MenuItem value="standardLanes">Standard Lanes</MenuItem>
            <MenuItem value="customLanes">Custom Lanes</MenuItem>
            <MenuItem value="allRandom">All Random</MenuItem>
            <MenuItem value="standardAlleys">Standard Alleys</MenuItem>
            <MenuItem value="customAlleys">Custom Alleys</MenuItem>
            <MenuItem value="waterfallStart">Waterfall Start</MenuItem>
            <MenuItem value="mejorPeor">Mejor a Peor (campo)</MenuItem>
            <MenuItem value="peorMejor">Peor a Mejor (campo)</MenuItem>
            <MenuItem value="alphabetic">Alfabético (campo)</MenuItem>
            <MenuItem value="numCompetidor"># Competidor (campo)</MenuItem>
          </Select>
        </FormControl>

        {/* OrdenHeat */}
        <FormControl fullWidth sx={{ mb: 2 }} size="small">
          <InputLabel>Orden del Heat</InputLabel>
          <Select
            label="Orden del Heat"
            value={massEditValues.ordenHeat}
            onChange={(e) =>
              setMassEditValues((prev) => ({ ...prev, ordenHeat: e.target.value }))
            }
          >
            <MenuItem value={NO_CHANGE}>No cambiar</MenuItem>
            <MenuItem value="fastToSlow">Más rápido al más lento</MenuItem>
            <MenuItem value="slowToFast">Más lento al más rápido</MenuItem>
            <MenuItem value="randomOrder">Aleatorio</MenuItem>
            <MenuItem value="mejorPeor">Mejor a Peor (campo)</MenuItem>
            <MenuItem value="peorMejor">Peor a Mejor (campo)</MenuItem>
          </Select>
        </FormControl>

        {/* TipoRondas */}
        <FormControl fullWidth sx={{ mb: 2 }} size="small">
          <InputLabel>Tipo de Rondas</InputLabel>
          <Select
            label="Tipo de Rondas"
            value={massEditValues.tipoRondas}
            onChange={(e) =>
              setMassEditValues((prev) => ({ ...prev, tipoRondas: e.target.value }))
            }
          >
            <MenuItem value={NO_CHANGE}>No cambiar</MenuItem>
            <MenuItem value="soloFinales">Solo Finales</MenuItem>
            <MenuItem value="prelimFinal">Preliminares/Final</MenuItem>
            <MenuItem value="prelimSemiFinal">Prelim/Semis/Final</MenuItem>
            <MenuItem value="prelimQtrsSemisFinal">Prelim/Cuartos/Semis/Final</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" onClick={handleSave}>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
